var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPageDictionary", {
                attrs: {
                  data: _vm.dictionary,
                  loading: _vm.isMutationLoading,
                  loadingData: _vm.isFormLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  submit: _vm.formDictionarySubmit,
                  "delete-dictionary": _vm.deleteDictionary,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmDictionaryRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }